import { OptInGetRes, OptInUpdateReq, TransformedOptIn } from '../models/opt-in.model';

export const getUpdatedOptInState = (prevState: OptInGetRes, currentState: OptInUpdateReq): OptInGetRes => {
  const transformedCurrentOptIn = getTransformedOptIn(currentState);
  return prevState.map((obj) =>
    transformedCurrentOptIn[obj.featureType] ? { ...obj, ...transformedCurrentOptIn[obj.featureType] } : obj
  );
};

const getTransformedOptIn = (req: OptInUpdateReq): TransformedOptIn => {
  const res = {};
  for (const obj of req) {
    res[obj.featureType] = obj;
  }
  return res as TransformedOptIn;
};
